var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header mb-10"},[_c('v-app-bar',[_c('v-card',{staticClass:"flex-grow-1 d-flex align-center elevation-0",attrs:{"flat":!_vm.isToolbarDetached}},[_c('v-card-title',{staticClass:"pa-0 text-h5"},[_vm._v("Сертификация КТЗ")])],1)],1),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }